function TagField() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($scope, $parse, $q, Classes) {
			var self = this;
			this.queries_cache = [];
			
			this.loadTags = function($query) {
				for (var i=0; i<self.queries_cache.length; i++) {
					if (self.queries_cache[i].query == $query) {
						return $q.resolve(self.queries_cache[i].tags);
					}
				}
				return self.field.dict({
					filter:{"title ~* ?": $query},
					data: {}
				}).then(function(dict){
					var tags = dict.map(function(item){return {text:item[1]};})
					self.queries_cache.splice(0, 0, [{query: $query, tags: tags}]);
					if (self.queries_cache.length > 10) self.queries_cache.length = 10;
					return tags;
				});
			}
			
			
			
			this.addTag = function($tag) {
				self.object[self.field.name] = self.object[self.field.name] || [];
				self.object[self.field.name].push($tag.text)
			}
			this.removeTag = function($tag) {
				self.object[self.field.name] = self.object[self.field.name] || [];
				self.object[self.field.name].splice(self.object[self.field.name].indexOf($tag.text), 1)
			}

			this.dictionary = [];
			if (this.field.client && this.field.client.display == "checkboxes") {
				this.loadTags().then(function(tags){
					[].push.apply(self.dictionary, tags);

					$scope.$watch(function() {return self.object[self.field.name]}, function(value) {
						if (value && value.length) {
							for (var i=0; i<self.dictionary.length; i++) {
								self.dictionary[i].selected = false;
								for (var t=0; t<value.length; t++) {
									if (self.dictionary[i].text == value[t]) self.dictionary[i].selected = true;
								}
							}
						} else {
							for (var i=0; i<self.dictionary.length; i++) self.dictionary[i].selected = false;
						}
					});
				});
			} else {
				this.tags = [];
				$scope.$watch(function() {return self.object[self.field.name]}, function(value) {
					if (value && value.length) {
						self.tags = value.map(function(item) {return {text:item}});
					} else {
						self.tags = [];
					}
				});
			}

			

			window.tCtrl = this;

		},
		controllerAs: '$tagField'
	}
}



function TagFieldController($scope, $parse) {

	var self = this;
	var cls = $scope.object.getClass();
	
	if(!$scope.object[$scope.field.name])
		$scope.object[$scope.field.name] = [];	

	if(!$scope.object[$scope.field.name])
		$scope.object[$scope.field.name] = [];

	this.loadTags = function($query) {
		return cls[$scope.field.name + '__dict']({
			filter:{"title ~* ?": $query},
			data: {}
		}).then(function(dict){
			return dict.map(function(item){return {text:item[1]};})
		});
	}

	this.tags = [];
	$scope.$watch('object.' + $scope.field.name, function(value) {
		if (value && value.length) {
			self.tags = value.map(function(item) {return {text:item}});
		} else {
			self.tags = [];
		}
	});
	
	this.addTag = function($tag) {
		$scope.object[$scope.field.name].push($tag.text)
	}
	this.removeTag = function($tag) {
		$scope.object[$scope.field.name].splice($scope.object[$scope.field.name].indexOf($tag.text), 1)
	}

	window.tCtrl = this;
}




angular.module('forms.fields.tags', ['ngTagsInput'])
.controller('TagFieldController', TagFieldController)
.directive('tagField', TagField)
